import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { createWhitelistFilter } from "redux-persist-transform-filter";
import { routerMiddleware } from "react-router-redux";
import SetTransform from "./transforms";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { createBrowserHistory as createHistory } from "history";

const history = createHistory();
const initialState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

const persistConfig = {
  key: "app",
  storage: storage,
  transforms: [SetTransform, createWhitelistFilter(["form"], [])],
  whitelist: ["form"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(persistedReducer, initialState, composedEnhancers);
const persistor = persistStore(store);

export { history, store, persistor };

history.listen(location => {
  if (typeof gtag === "function") {
    // Send information to google analytics
    gtag("config", "UA-107000079-2", {
      page_path: location.pathname + location.search
    });
  }
});



// WEBPACK FOOTER //
// ./src/store.js